import { useEndpointFetch } from '../network/useEndpointFetch';

export const useViewUpcomingRoster = () => {
  return useEndpointFetch<{}, {}>(
    '/vm/volunteer/onboarding/view-upcoming-rosters'
  );
};
